import { useMaterialReactTable } from "material-react-table";
import { localizationTextObject } from "../../../utils/constants";
import { COLORS } from "../../APS/Learning/constants/config";
import { Button, Box, Tooltip, IconButton } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import Pen01 from "../../Nucleo-Icons/pen-01";
import EditRowDialog from "./EditRowDialog";
import CreateMaterialModal from "./CreateMeterialModal";

export function useTableInstance({
  columns,
  data,
  openSnackbar,
  setUpdateStatus,
  handleDelete,
}) {
  const ActionToolbar = ({ table }) => {
    const hasSelection =
      Object.keys(table.getState().rowSelection || {}).length > 0;
    const getSelectedRows = () => {
      const rowSelection = table.getState().rowSelection;
      if (!rowSelection || Object.keys(rowSelection).length === 0) return [];
      return Object.keys(rowSelection)
        .filter((id) => rowSelection[id])
        .map((id) => {
          return data.find((row) => String(row.material_id) === id);
        })
        .filter(Boolean)
        .map((row) => row.material_id);
    };
    const handleDeleteClick = () => {
      const selectedIds = getSelectedRows();
      if (selectedIds.length === 0) {
        openSnackbar("삭제할 항목을 선택하세요.", "warning");
        return;
      }
      if (
        window.confirm(`${selectedIds.length}개의 항목을 삭제하시겠습니까?`)
      ) {
        handleDelete(selectedIds);
      }
    };
    return (
      <div className="toolbar_container">
        <Button
          variant="contained"
          color="success"
          onClick={() => {
            table.setCreatingRow(true);
          }}
          startIcon={<CheckIcon />}
        >
          등록
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={handleDeleteClick}
          disabled={!hasSelection}
          startIcon={<CloseIcon />}
        >
          삭제
        </Button>
      </div>
    );
  };
  const table = useMaterialReactTable({
    columns,
    data,
    enableRowSelection: true,
    localization: localizationTextObject,
    getRowId: (row) => String(row.material_id),
    initialState: { columnVisibility: { material_id: false } },
    enableEditing: true,
    enablePagination: true,
    enableTopToolbar: false,
    enableColumnFilter: false,
    muiTableContainerProps: {
      sx: {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        height: "100%",
      },
    },
    muiTablePaperProps: {
      sx: {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        height: "100%",
      },
    },
    muiTableBodyCellProps: {
      sx: {
        fontSize: "14px",
        fontWeight: "500",
        padding: "10px !important",
        color: "#111",
      },
    },
    muiTableBodyRowProps: {
      sx: {
        backgroundColor: "#fff",
        height: "60px",
      },
    },
    muiTableHeadProps: {
      sx: {
        boxSizing: "border-box",
        "& tr": {
          boxSizing: "border-box",
          paddingBottom: 0,
          background: "#fff",
          color: "#111",
          borderTop: `1px solid ${COLORS.BORDER_BRIGHT}`,
          // borderBottom: `1px solid ${COLORS.BORDER_BRIGHT}`,
          "&: th": {
            textAlign: "",
            padding: 0,
          },
        },
      },
    },
    positionActionsColumn: "last",
    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: "flex", width: "50px" }}>
        <Tooltip title="수정">
          <IconButton onClick={() => table.setEditingRow(row)}>
            <Pen01 />
          </IconButton>
        </Tooltip>
      </Box>
    ),
    editDisplayMode: "modal",
    renderCreateRowDialogContent: ({ table }) => (
      <CreateMaterialModal
        table={table}
        openSnackbar={openSnackbar}
        setUpdateStatus={setUpdateStatus}
      />
    ),
    renderEditRowDialogContent: ({ internalEditComponents, row, table }) => (
      <>
        <EditRowDialog
          table={table}
          row={row}
          initialData={row.original}
          openSnackbar={openSnackbar}
          setUpdateStatus={setUpdateStatus}
        />
      </>
    ),
  });

  return { table, ActionToolbar };
}
